const featureItems = [
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '超过20000部电影资源，涵盖动作、喜剧、科幻、悬疑、爱情、动画等全品类，经典老片与最新大片一应俱全。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清流畅',
    desc: '最高1080P超清画质，智能自适应码率技术，无论网络快慢都能享受流畅无卡顿的观影体验，拒绝缓冲等待。',
  },
  {
    icon: 'ri-gift-line',
    title: '免费观看',
    desc: '无需注册、无需付费、无隐藏收费，打开菲菲影院即可免费观看全部电影资源，让好电影触手可及。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">我们的优势</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">为什么百万影迷选择菲菲影院</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureItems.map((item) => (
            <div key={item.title} className="rounded-xl bg-background-50 p-6 md:p-8 text-center flex flex-col items-center">
              <span className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-5">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="text-lg font-medium text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}